import React from 'react'
import { Link } from 'react-router-dom'
import img2 from "../../../assets/images/home_page_4/advertise/03.png"

const AdvertiseOne = () => {
    return (
        <div>
            <section id="advertise-one" className="advertise-one-main-block">
                <div className="container">
                    <div className="advertise-one-block">
                        <div className="row">
                            <div className="col-lg-6 col-md-6">
                                <div className="home-banner-dtl">
                                    <h4 className="home-banner-sub-heading">Exclusive Offer <span className="home-badge">-20% Off</span></h4>
                                    <h1 className="home-banner-heading">Super Fast Performance</h1>
                                    <p>We have prepared special discounts for you on electronic products. Don&#x27;t miss these opportunities...</p>
                                    <Link title="" className="btn btn-primary">Shop Now<i className="flaticon-right-arrows"></i></Link>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <div className="advertise-one-img-block">
                                    <img src={img2} className="img-fluid" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="advertise-one-bottom-bg"></div>
                </div>
            </section>
        </div>
    )
}

export default AdvertiseOne